<div class="template-page" *ngIf="template">
	<div class="name-row">
		<label for="template-name">Template Name</label>
		<input pInputText type="text" id="template-name" [(ngModel)]="template.templateName" (ngModelChange)="isDirty = true" />
		<p *ngIf="errors.templateName" class="error">{{ errors.templateName }}</p>
	</div>

	<div class="workspace-toolbar">
		<p-selectButton id="editor-mode" [options]="modeOptions" [(ngModel)]="modeSelection" (onChange)="requestModeChange($event.value)" optionLabel="label" optionValue="value" [allowEmpty]="false">
			<ng-template let-item pTemplate>
				<i [class]="item.icon"></i>&nbsp;{{ item.label }}
			</ng-template>
		</p-selectButton>
		<p-dropdown [options]="templates" [optionLabel]="'templateName'" id="template" [(ngModel)]="selectedTemplate" (onChange)="selectTemplate()" [autoDisplayFirst]="false" placeholder="Start from template…" [style]="{ width: '320px' }" />
		<span class="spacer"></span>
		<ng-container *ngIf="isHtml">
			<span class="importing" *ngIf="expertEditor?.importing === true"><i class="pi pi-spin pi-spinner"></i> Importing…</span>
			<span class="material-symbols-outlined info-icon" [pTooltip]="expertHelp" [escape]="false" tooltipPosition="bottom" [appendTo]="'body'" tooltipStyleClass="tooltip-help">info</span>
			<button pButton type="button" [text]="true" icon="pi pi-images" label="Copy images to storage" (click)="expertEditor?.reimportImages()" [disabled]="!template.templateHtml"></button>
			<button pButton type="button" [text]="true" icon="pi pi-upload" label="Upload an image" (click)="expertEditor?.openImagePicker()"></button>
		</ng-container>
	</div>

	<p *ngIf="errors.templateHtml" class="workspace-error">{{ errors.templateHtml }}</p>

	<!-- Designer: Unlayer with the substitution sidebar -->
	<div class="designer" *ngIf="!isHtml">
		<div class="sidebar">
			<app-substitution-fields [showVimeoOption]="true"></app-substitution-fields>
		</div>
		<div class="designer-main">
			<email-editor (loaded)="editorLoaded($event)" [options]="editorOptions" [minHeight]="'0px'"></email-editor>
		</div>
	</div>

	<!-- Expert: HTML editor + live preview -->
	<app-expert-html-editor *ngIf="isHtml" [(html)]="template.templateHtml" (changed)="isDirty = true"></app-expert-html-editor>
</div>
